var map = {
	"./azerbaijan1.webp": 7471,
	"./azerbaijan2.webp": 830,
	"./azerbaijan3.webp": 6857,
	"./azerbaijan4.webp": 352,
	"./azerbaijanBg.jpeg": 4510,
	"./azerbaijanVisasteps.webp": 6744,
	"./azerbaijanmetro.webp": 5641,
	"./baku1.jpg": 8287,
	"./baku10.webp": 7053,
	"./baku11.webp": 7138,
	"./baku12.webp": 8835,
	"./baku13.webp": 8400,
	"./baku2.webp": 698,
	"./baku3.jpeg": 2130,
	"./baku4.webp": 884,
	"./baku5.webp": 1895,
	"./baku6.webp": 1222,
	"./baku7.webp": 1249,
	"./baku8.webp": 3632,
	"./baku9.webp": 9395,
	"./bakubg.jpg": 4713,
	"./homeBg.webp": 9605,
	"./krabi.webp": 2450,
	"./malaysia.webp": 7422,
	"./tldrBlogsLogoTrans.webp": 3723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2151;